import { Flex } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { Field } from '../../components/Form';
import Controls from './Controls';

// Helper function to strip HTML tags and get plain text for JSON-LD
const htmlToText = (html) => {
  if (!html) return '';
  // Create a temporary DOM element to parse HTML
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  // Get text content and clean up extra whitespace
  return tmp.textContent || tmp.innerText || '';
};

const FaqQuestionAnswer = ({ field, index, name }) => {
  const { setValue, register } = useFormContext();
  const faqs = useWatch({ name: `${name}[${index}].faqs` });
  const faqHeading = useWatch({ name: `${name}[${index}].heading` });

  useEffect(() => {
    register(`${name}[${index}].jsonLd`);
  }, [index, name, register]);

  useEffect(() => {
    if (!faqs || faqs.length === 0) {
      setValue(`${name}[${index}].jsonLd`, '');
      return;
    }

    const mainEntity =
      faqs
        ?.filter((item) => item?.question && item?.answer)
        .map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: htmlToText(item.answer), // Clean HTML to plain text for JSON-LD
          },
        })) || [];

    const jsonLd = JSON.stringify(
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'name': faqHeading,
        mainEntity,
      },
      null,
      2
    );

    setValue(`${name}[${index}].jsonLd`, jsonLd);
  }, [faqs, faqHeading, index, name, setValue]);

  return (
    <Flex
      w="100%"
      direction="column"
      align="flex-start"
      rounded="5px"
      bg="white"
      p="15px"
      mb="15px"
    >
      <Controls index={index} />
      <Flex direction="column" w="100%">
        <Field
          name={`${name}[${index}].heading`}
          component="text"
          placeholder="FAQ heading"
          label="Heading"
        />
        <Field
          name={`${name}[${index}].faqs`}
          component="repeater"
          singleName="FAQ"
          layout="vertical"
          width="100%"
          minWidth="100%"
          label="FAQs"
          isRepeater={true}
          fieldArray={[
            {
              name: 'question',
              component: 'text',
              placeholder: 'Question',
              label: 'Question',
            },
            {
              name: 'answer',
              component: 'richtext',
              placeholder: 'Answer',
              label: 'Answer',
            },
          ]}
        />
        <Field
          name={`${name}[${index}].type`}
          component="text"
          placeholder=""
          defaultValue="faqQuestionAnswe"
          showField={false}
        />
        <Field
          name={`${name}[${index}].jsonLd`}
          component="textarea"
          placeholder=""
          showField={false}
        />
      </Flex>
    </Flex>
  );
};

export default FaqQuestionAnswer;

